import { render, staticRenderFns } from "./liangpinlv.vue?vue&type=template&id=34774494&"
import script from "./liangpinlv.vue?vue&type=script&lang=js&"
export * from "./liangpinlv.vue?vue&type=script&lang=js&"
import style0 from "./liangpinlv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports